var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysAttach = function SvgSysAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M16 9.69v6.04a4.42 4.42 0 0 1-1.172 3.02c-.75.8-1.768 1.25-2.829 1.25-1.06 0-2.078-.45-2.828-1.25A4.42 4.42 0 0 1 8 15.73V6.899c0-.38.07-.757.206-1.109.137-.352.337-.671.589-.94a2.71 2.71 0 0 1 .881-.629c.33-.145.683-.22 1.04-.22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M8 13.91V6.853a2.848 2.848 0 0 1 2.848-2.848h.033a2.848 2.848 0 0 1 2.848 2.848v7.057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M13.729 7.802v7.452a1.5 1.5 0 1 1-3 0V8.285"
  })));
};
export default SvgSysAttach;